import React from "react";

export const UserDataDeletion = () => {
  return <div>User Data Deletion</div>;
};
